import { FC } from "react";
import styles from './styles.module.scss';

interface Service {
    id: string;
    title: string;
    description: string;
    features: string[];
    icon: JSX.Element;
    color: string;
    priceFrom?: string;
}

const services: Service[] = [
    {
        id: 'educational-platforms',
        title: 'Образовательные платформы',
        description: 'Создание комплексных LMS-систем для онлайн и оффлайн обучения с полным функционалом',
        features: [
            'Личные кабинеты студентов и преподавателей',
            'Интерактивные уроки с видео и тестами',
            'Система домашних заданий и проверки',
            'Аналитика прогресса и автоматизация'
        ],
        icon: (
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M6 18L24 8L42 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="6" y="18" width="36" height="22" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M6 24H42" stroke="currentColor" strokeWidth="2"/>
                <rect x="14" y="28" width="8" height="12" stroke="currentColor" strokeWidth="2"/>
                <rect x="26" y="28" width="8" height="12" stroke="currentColor" strokeWidth="2"/>
            </svg>
        ),
        color: '#8489fb',
        priceFrom: 'от 500 000 ₽'
    },
    {
        id: 'web-platforms',
        title: 'Веб-приложения',
        description: 'Разработка современных SPA и веб-сервисов на React, TypeScript с Python backend',
        features: [
            'SPA на React + TypeScript',
            'Python (FastAPI/Django) backend',
            'PostgreSQL базы данных',
            'WebSocket для реального времени'
        ],
        icon: (
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="6" y="10" width="36" height="28" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M6 16H42" stroke="currentColor" strokeWidth="2"/>
                <circle cx="11" cy="13" r="1" fill="currentColor"/>
                <circle cx="15" cy="13" r="1" fill="currentColor"/>
                <circle cx="19" cy="13" r="1" fill="currentColor"/>
                <path d="M16 24L20 28L16 32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M24 32H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        ),
        color: '#5B21CC',
        priceFrom: 'от 250 000 ₽'
    },
    {
        id: 'ai-solutions',
        title: 'AI и ML решения',
        description: 'Разработка решений с использованием искусственного интеллекта и машинного обучения',
        features: [
            'Python + TensorFlow/PyTorch',
            'Обработка естественного языка',
            'Компьютерное зрение',
            'Интеграция с OpenAI API'
        ],
        icon: (
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="10" stroke="currentColor" strokeWidth="2"/>
                <circle cx="24" cy="24" r="4" fill="currentColor"/>
                <path d="M24 4V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M24 34V44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M4 24H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M34 24H44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M10 10L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M31 31L38 38" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M38 10L31 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M17 31L10 38" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        ),
        color: '#00C2A8',
        priceFrom: 'от 300 000 ₽'
    },
    {
        id: 'automation',
        title: 'Автоматизация и боты',
        description: 'Telegram-боты и сервисы для автоматизации бизнес-процессов на Python',
        features: [
            'Python Telegram боты',
            'Автоматизация рассылок',
            'Интеграция с CRM',
            'PostgreSQL + Redis кэширование'
        ],
        icon: (
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="12" cy="24" r="4" stroke="currentColor" strokeWidth="2"/>
                <circle cx="36" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                <circle cx="36" cy="36" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 24H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M24 24L32 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M24 24L32 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        ),
        color: '#FF6B6B',
        priceFrom: 'от 100 000 ₽'
    }
];

export const DevelopmentServices: FC = () => {
    return (
        <div className={styles.services} id="services">
            <div className={styles.__in}>
                
                <div className={styles.header}>
                    <div className={styles.badge}>
                        Наши услуги
                    </div>
                    <h2 className={styles.title}>
                        Разработка IT-решений
                    </h2>
                    <p className={styles.subtitle}>
                        Создаем образовательные платформы, веб-приложения и AI-решения на современном стеке технологий
                    </p>
                </div>

                <div className={styles.grid}>
                    {services.map((service, index) => (
                        <div 
                            key={service.id} 
                            className={styles.card}
                            style={{ 
                                '--card-color': service.color,
                                animationDelay: `${index * 0.1}s`
                            } as React.CSSProperties}
                        >
                            <div className={styles.card_header}>
                                <div className={styles.icon} style={{ color: service.color }}>
                                    {service.icon}
                                </div>
                            </div>
                            
                            <div className={styles.card_content}>
                                <h3 className={styles.card_title}>{service.title}</h3>
                                <p className={styles.card_description}>{service.description}</p>
                                
                                {service.priceFrom && (
                                    <div className={styles.price_badge}>
                                        {service.priceFrom}
                                    </div>
                                )}
                                
                                <ul className={styles.features}>
                                    {service.features.map((feature, idx) => (
                                        <li key={idx} className={styles.feature}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path 
                                                    d="M13 4L6 11L3 8" 
                                                    stroke="currentColor" 
                                                    strokeWidth="2" 
                                                    strokeLinecap="round" 
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className={styles.card_footer}>
                                <a href="#feedback">
                                    <button className={styles.button}>
                                        Обсудить проект
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path 
                                                d="M6 12L10 8L6 4" 
                                                stroke="currentColor" 
                                                strokeWidth="2" 
                                                strokeLinecap="round" 
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </button>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={styles.cta}>
                    <div className={styles.cta_content}>
                        <h3 className={styles.cta_title}>Есть идея проекта?</h3>
                        <p className={styles.cta_text}>
                            Обсудим ваш проект и предложим оптимальное решение
                        </p>
                    </div>
                    <a href="#feedback">
                        <button className={styles.cta_button}>
                            Обсудить проект
                        </button>
                    </a>
                </div>

            </div>
        </div>
    );
};

